/* unplugin-vue-components disabled */import script from "./CheckNameAndOwner.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckNameAndOwner.vue?vue&type=script&lang=ts&setup=true"

import "./CheckNameAndOwner.vue?vue&type=style&index=0&id=54a70e52&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a70e52"]])

export default __exports__